import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

import { ButtonCloseDialogComponent } from '../button-close-dialog/button-close-dialog.component';
import { A11yModule } from '@angular/cdk/a11y';

import { MatExpansionModule } from '@angular/material/expansion';
import { ButtonSaveComponent } from '../button-save/button-save.component';
import { ButtonDeleteComponent } from '../button-delete/button-delete.component';
import { ButtonCloseComponent } from '../button-close/button-close.component';
import { AccionesDialog } from '@models/base/identificadores.model';
import { ButtonDeleteAndCancelComponent } from '../button-delete-and-cancel/button-delete-and-cancel.component';
import { CreateKeyValueRequest } from '@models/base/createKeyValueRequest.model';
import { UpdateKeyValueRequest } from '@models/base/updateKeyValueRequest.model';
import { BaseDto } from '@models/base/baseDto.model';

@Component({
    selector: 'app-dialog-form',
    imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatDialogModule, ButtonCloseDialogComponent, A11yModule, MatExpansionModule, ButtonSaveComponent, ButtonDeleteAndCancelComponent, ButtonCloseComponent],
    templateUrl: './dialog-form.component.html',
    styleUrl: './dialog-form.component.css',
    //changeDetection: ChangeDetectionStrategy.OnPush,
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DialogFormComponent {
  dialogRef = inject<MatDialogRef<DialogFormComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);
  private fb = inject(FormBuilder);

  form: FormGroup;
  localData: any;
  get f() { return this.form.controls; }
  constructor() {

    this.form = this.fb.group({
      Descripcion: [this.data?.item?.descripcion || '', Validators.compose([Validators.required, Validators.maxLength(100)])],
      Observaciones: [this.data?.item?.observaciones || '',Validators.compose([ Validators.maxLength(200)])]
    });
  }

  agregar(){
    this.dialogRef.close({event:AccionesDialog.Agregar, data: this.data.item  });
  }

  modificar(){
    this.dialogRef.close({event:AccionesDialog.Modificar, data: this.data.item  });
  }

  eliminar(){
    this.dialogRef.close({event:AccionesDialog.Eliminar, data: this.data.item as BaseDto});
  }

  cancelar() {
    this.dialogRef.close({event:AccionesDialog.Cancelar, data: this.data});
  }
}
